export default __webpack_public_path__ + "static/media/border-smooth.e557f05c.png";